import VueI18n from 'vue-i18n'
import Vue from 'vue'
import en from "./lang/en_US";
import zh from "./lang/zh_CN";
import enLocale from 'element-ui/lib/locale/lang/en'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
import locale from 'element-ui/lib/locale'
import ElementUI from 'element-ui';
Vue.use(VueI18n)
// 2、创建英文语言包对象

const messages = {
  zh: { ...zh, ...zhLocale },
  en: { ...en, ...enLocale }
}
let lang = localStorage.getItem('lang') || navigator.language.split('-')[0]

const i18n = new VueI18n({
  messages,
  locale: lang
})


Vue.use(ElementUI, {
  i18n: (key, value) => i18n.t(key, value)
})
export default i18n



// WEBPACK FOOTER //
// ./src/i18n/index.js